import { BB_ATTRIBUTES_MODE } from '/bb/constants.js';
import { normalizeAttributesMode } from '/bb/attributes-config.js';

export const BB_WARNING = {
  MISSING_APP_ID: 'missing_app_id',
  NO_FORMS_DETECTED: 'no_forms_detected',
  NO_SECTIONS_DETECTED: 'no_sections_detected',
  STORAGE_UNAVAILABLE: 'storage_unavailable',
  LAST_COLLECT_FAILED: 'last_collect_failed',
  LAST_COLLECT_TIMEOUT: 'last_collect_timeout',
  INVALID_ATTRIBUTES_MODE: 'invalid_attributes_mode',
};

export const DEFAULT_HOLD_SUBMIT_TIMEOUT_MS = 1000;

/**
 * Normalize BB options from rsSDK('config', appId, { bb: ... }).
 *
 * @param {object} [bb]
 * @returns {{
 *   enabled: boolean,
 *   auto: boolean,
 *   holdSubmitTimeoutMs: number,
 *   attributesMode: string,
 *   warnings: string[],
 * }}
 */
export function normalizeBbOptions(bb) {
  const raw = bb && typeof bb === 'object' ? bb : {};
  const warnings = [];
  const attributesMode = normalizeAttributesMode(raw.attributesMode);
  if (raw.attributesMode != null && attributesMode === null) {
    warnings.push(BB_WARNING.INVALID_ATTRIBUTES_MODE);
  }

  return {
    enabled: parseEnabled(raw.enabled),
    auto: !!raw.auto,
    holdSubmitTimeoutMs: parseHoldSubmitTimeout(raw.holdSubmitTimeout),
    attributesMode: attributesMode || BB_ATTRIBUTES_MODE.MERGE,
    warnings,
  };
}

function parseEnabled(value) {
  if (value == null) return true;
  return !!value;
}

function parseHoldSubmitTimeout(value) {
  if (value == null || value === '') return DEFAULT_HOLD_SUBMIT_TIMEOUT_MS;

  const timeout = Number(value);
  return Number.isFinite(timeout) && timeout >= 0 ? timeout : DEFAULT_HOLD_SUBMIT_TIMEOUT_MS;
}
